import { reduce, mergeDeepLeft, mergeWith, concat } from "ramda"
import { isArray, isString } from "./types"


/** 
merge array of elements from given list of objects
@param keys { string[] } array of string to get arrays to be merged from give list objects
@param data { objects[] } array of objects which contains the list to be merged.
example:  mergeObjects([
  {a: 10},
  {b: 10},
  {c: 20, "sub": {"s": "d", "a": 10, "logic": true}}
])
mergeObjects => returns {"a": 10, "b": 10, "c": 20, "sub": {"a": 10, "logic": true, "s": "d"}}
*/


export const mergeObjects = (objects: any[]) => {
  return reduce(mergeDeepLeft, {}, objects)
}

/** 
merge array of elements from given list of objects concat if there is same key on other objects
@param data { objects[] } array of objects which contains the list to be merged.
example:  mergeWithConcat([
 { a: true, values: [10, 20] },
 { b: true, c: "Doc", values: [15, 35] },
 { b: true, values: [45, 55] }
])

//=> { a: true, b: [true, true], c: "Doc", values: [10, 20, 15, 35, 45, 55] }
*/
export const mergeWithConcat = (objects: any[]) => {
  return reduce(mergeWith((a: any, b: any) => {
    if (!isArray(a) && !isString(b)) {
      return a
    }
    return concat(a, b)
  }), {}, objects)
}


/** 
merge array of elements from given list of objects concat if there is same key on other objects
@param data { objects[] } array of objects which contains the list to be merged.
example:  mergeWithConcat([
 { a: true, c: "Document",values: [10, 20] },
 { b: true, c: "Doc", values: [15, 35] },
 { b: true, values: [45, 55] }
])

//=> { a: true, b: true, c: "Doc", values: [10, 20, 15, 35, 45, 55] }
*/
export const mergeWithArrayConcat = (objects: any[]) => {
  return reduce(mergeWith((a: any, b: any) => {
    if (!isArray(a)) {
      return a
    }
    return concat(a, b)
  }), {}, objects)
}